import { BillViewState } from './types';
import { BillSidebarTabs } from '../../helpers/BillHelper';

const initialBillViewState: BillViewState = {
  billSidebarCurrentTab: BillSidebarTabs.DETAILS,
  billListCacheKeys: [],
};

export default initialBillViewState;
